/*!
 * Lumia Paws — Scroll & Hover Animations
 * Intersection Observer scroll reveals + stagger, no dependencies.
 */
(function () {
  'use strict';

  // Bail early if browser doesn't support IntersectionObserver
  if (!('IntersectionObserver' in window)) return;
  // Respect accessibility preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ANIM_CLASS = 'lp-animate';
  var IN_CLASS = 'lp-in';
  var STAGGER_CLASS = 'lp-stagger';
  var HEADING_CLASS = 'lp-heading';

  // Selectors for card-like elements that get scroll + stagger
  var CARD_SELECTORS = [
    'product-card',
    '.card-wrapper',
    '.product-card',
    '.collection-card',
    '.collection-list__item',
  ];

  // Selectors for section headings (slide-in from left)
  var HEADING_SELECTORS = [
    '.section-header h2',
    '.section-header h3',
    '.section-header .title',
    '.product-list .title',
    '.collection-list .title',
    '.lp-trust-strip',
  ];

  var observer;

  function createObserver() {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(IN_CLASS);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px',
      }
    );
  }

  function observeEl(el) {
    if (!observer) createObserver();
    observer.observe(el);
  }

  function initCards() {
    CARD_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (card) {
        if (card.classList.contains(ANIM_CLASS)) return; // already set up
        card.classList.add(ANIM_CLASS);

        // Mark parent for stagger delays
        var parent = card.parentElement;
        if (parent && !parent.classList.contains(STAGGER_CLASS)) {
          parent.classList.add(STAGGER_CLASS);
        }

        observeEl(card);
      });
    });
  }

  function initHeadings() {
    HEADING_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.classList.contains(HEADING_CLASS)) return;
        el.classList.add(HEADING_CLASS);
        observeEl(el);
      });
    });
  }

  function initHero() {
    // Animate the hero content block on entry
    var hero = document.querySelector('.hero .spacing-style, .section--hero .spacing-style, [data-section-type="hero"] .spacing-style');
    if (hero && !hero.classList.contains('lp-hero-content')) {
      hero.classList.add('lp-hero-content');
    }
  }

  function init() {
    initCards();
    initHeadings();
    initHero();
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify reloads a section (theme editor live preview)
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
